import { Suspense, lazy } from 'react';

import { useTranslation } from 'react-i18next';

import Plans from '@/components/Plans';
import { SITE_NAME } from '@/config';
import { usePlans } from '@/hooks/price';

const FaqSection = lazy(() => import('./Faqs'));

function Pricing() {
	const { t } = useTranslation();
	const plansData = usePlans();

	return (
		<div className="relative m-auto flex flex-col justify-center gap-5 px-5 pb-5 lg:w-[1028px] lg:gap-6">
			<div className="absolute left-0 right-0 top-[22.5rem] z-[-1] mx-auto h-[280px] w-[280px] max-w-[100vw] rounded-full bg-red blur-[100px] lg:top-[30rem] lg:h-[294px] lg:w-[294px] lg:blur-[150px]" />

			<div className="mt-10 flex w-full flex-col items-center justify-between gap-5 lg:mt-[56px] lg:gap-6">
				<h1 className="max-w-[50rem] text-center font-title text-[2rem] font-semibold leading-[2.5rem] lg:mb-7 lg:text-[56px] lg:leading-[4rem]">
					{t('pricing.title', { siteName: SITE_NAME })}
				</h1>
			</div>

			<Plans plansData={plansData} />

			<Suspense>
				<FaqSection plansData={plansData} />
			</Suspense>
		</div>
	);
}

export default Pricing;
